import {globalHistory} from "@reach/router";

export function getPhaseForTestSystem ():string {
    const {location} = globalHistory
    const urlParameters = new URLSearchParams((location.search.substring(1)))

    return urlParameters.get("phase") || ''
}
